// This function will replace quotes with an alternative quote style if they are the first or last character
export const replaceQuotes = (text: string): string => {
  if (!text) return text;

  const startsWithQuote = text.startsWith('"');
  const endsWithQuote = text.endsWith('"');

  let result = text;

  if (startsWithQuote) {
    result = '“' + result.slice(1);
  }

  if (endsWithQuote && result.length > 1) {
    result = result.slice(0, -1) + '”';
  }

  return result;
};
